"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePermissionsService = void 0;
var debug_1 = require("debug");
var debug = (0, debug_1.default)('pl:BasePermissionsService');
var BasePermissionsService = /** @class */ (function () {
    function BasePermissionsService(currentUserProvider, forbiddenExceptionType, cacheManager, dynamicResolversGetter, permissionManagerCreator) {
        this.currentUserProvider = currentUserProvider;
        this.forbiddenExceptionType = forbiddenExceptionType;
        this.cacheManager = cacheManager;
        this.dynamicResolversGetter = dynamicResolversGetter;
        this.permissionManagerCreator = permissionManagerCreator;
    }
    BasePermissionsService.prototype.getCurrentUsersManager = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentUserId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentUserId = this.currentUserProvider.currentIdentityId;
                        if (!currentUserId) {
                            throw new this.forbiddenExceptionType();
                        }
                        return [4 /*yield*/, this.getManager(currentUserId, this.currentUserProvider.tokenDetails.token)];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        });
    };
    BasePermissionsService.prototype.getSubjectToEntityTypeMapping = function () {
        return __awaiter(this, void 0, void 0, function () {
            var manager;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrentUsersManager()];
                    case 1:
                        manager = _a.sent();
                        return [2 /*return*/, manager.getSubjectToDbModelMap()];
                }
            });
        });
    };
    BasePermissionsService.prototype.getManager = function (userId, userToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPermissionManager(userId, userToken)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BasePermissionsService.prototype.getAbility = function (userId, userToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPermissionManager(userId, userToken)];
                    case 1: return [2 /*return*/, (_a.sent()).ability];
                }
            });
        });
    };
    BasePermissionsService.prototype.hasPermissions = function (userId, userToken, subject, action) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPermissionManager(userId, userToken)];
                    case 1: return [2 /*return*/, (_a.sent()).hasPermission(subject, action)];
                }
            });
        });
    };
    BasePermissionsService.prototype.getCached = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cacheManager.get(userId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BasePermissionsService.prototype.invalidateCached = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cacheManager.del(userId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BasePermissionsService.prototype.getPermissionManager = function (userId, userToken) {
        return __awaiter(this, void 0, void 0, function () {
            var cached, permissionManager;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCached(userId)];
                    case 1:
                        cached = _a.sent();
                        if (!cached) {
                            cached = {};
                            this.cacheManager.set(userId, cached, 3600000);
                        }
                        cached.token = userToken;
                        permissionManager = cached.manager;
                        if (permissionManager) {
                            permissionManager.dynamicResolverGetter = this.dynamicResolversGetter;
                            return [2 /*return*/, permissionManager];
                        }
                        debug('Manager for user %o does not exists... requesting', userId);
                        permissionManager = this.permissionManagerCreator(this.dynamicResolversGetter);
                        return [4 /*yield*/, permissionManager.init()];
                    case 2:
                        _a.sent();
                        cached.manager = permissionManager;
                        return [2 /*return*/, permissionManager];
                }
            });
        });
    };
    return BasePermissionsService;
}());
exports.BasePermissionsService = BasePermissionsService;
